export default {
  'dashboard.TopSearch.ranking': 'Xếp hạng',
  'dashboard.TopSearch.searchKeyword': 'Từ khóa tìm kiếm',
  'dashboard.TopSearch.userCount': 'Số lượt tìm kiếm',
  'dashboard.TopSearch.weeklyGrowth': 'Tăng trưởng tuần',
  'dashboard.TopSearch.onlineHotSearch': 'Tìm kiếm hot trên website',
  'dashboard.TopSearch.searchUserCount': 'Số người dùng tìm kiếm',
  'dashboard.TopSearch.avgSearchFrequency': 'Tần suất tìm kiếm bình quân',
  'dashboard.TopSearch.metricDescription': 'Mô tả chỉ số',
};
